customElements.get("dbtfy-order-tracking-form") || customElements.define("dbtfy-order-tracking-form", class extends HTMLElement {
  constructor() {
    super();
    this.isArabic = String(document.documentElement.lang || "").toLowerCase().startsWith("ar") || document.documentElement.dir === "rtl";
    this.tabOrder = document.getElementById("tab-btn-order");
    this.tabCourier = document.getElementById("tab-btn-courier");
    this.panelOrder = document.getElementById("panel-order");
    this.panelCourier = document.getElementById("panel-courier");

    this.orderRefInput = document.getElementById("order-ref-input");
    this.orderContactInput = document.getElementById("order-contact-input");
    this.orderRefSubmit = document.getElementById("order-ref-submit");

    this.courierTrackingInput = document.getElementById("order-tracking-number");
    this.courierTrackingSubmit = document.getElementById("order-tracking-submit");

    this.directResult = document.getElementById("sotg-direct-result");
    this.resultCarrier = document.getElementById("sotg-result-carrier");
    this.resultMsg = document.getElementById("sotg-result-msg");
    this.resultBtn = document.getElementById("sotg-result-btn");

    this.notice = this.querySelector(".dbtfy-order-tracking-notice");
  }

  connectedCallback() {
    this.bindTabs();
    this.bindForms();
    this.checkUrlParams();
  }

  bindTabs() {
    if (this.tabOrder && this.tabCourier) {
      this.tabOrder.addEventListener("click", () => this.switchTab("order"));
      this.tabCourier.addEventListener("click", () => this.switchTab("courier"));
    }
  }

  switchTab(tab) {
    this.clearNotice();
    if (this.directResult) this.directResult.style.display = "none";

    if (tab === "order") {
      this.tabOrder.classList.add("active");
      this.tabOrder.setAttribute("aria-selected", "true");
      this.tabCourier.classList.remove("active");
      this.tabCourier.setAttribute("aria-selected", "false");
      this.panelOrder.style.display = "block";
      this.panelOrder.classList.add("active");
      this.panelCourier.style.display = "none";
      this.panelCourier.classList.remove("active");
      if (this.orderRefInput) this.orderRefInput.focus();
    } else {
      this.tabCourier.classList.add("active");
      this.tabCourier.setAttribute("aria-selected", "true");
      this.tabOrder.classList.remove("active");
      this.tabOrder.setAttribute("aria-selected", "false");
      this.panelCourier.style.display = "block";
      this.panelCourier.classList.add("active");
      this.panelOrder.style.display = "none";
      this.panelOrder.classList.remove("active");
      if (this.courierTrackingInput) this.courierTrackingInput.focus();
    }
  }

  bindForms() {
    if (this.panelOrder) {
      this.panelOrder.addEventListener("submit", this.onOrderSubmit.bind(this));
    }
    if (this.panelCourier) {
      this.panelCourier.addEventListener("submit", this.onCourierSubmit.bind(this));
    }
  }

  showNotice(msg, type = "error") {
    if (!this.notice) return;
    this.notice.textContent = msg;
    this.notice.style.display = "block";
    if (type === "error") {
      this.notice.style.color = "#d9383a";
      this.notice.style.backgroundColor = "rgba(217, 56, 58, 0.08)";
      this.notice.style.border = "1px solid rgba(217, 56, 58, 0.25)";
    } else if (type === "warning") {
      this.notice.style.color = "#856404";
      this.notice.style.backgroundColor = "rgba(255, 193, 7, 0.15)";
      this.notice.style.border = "1px solid rgba(255, 193, 7, 0.35)";
    } else {
      this.notice.style.color = "#155724";
      this.notice.style.backgroundColor = "rgba(40, 167, 69, 0.15)";
      this.notice.style.border = "1px solid rgba(40, 167, 69, 0.35)";
    }
  }

  clearNotice() {
    if (this.notice) {
      this.notice.style.display = "none";
      this.notice.textContent = "";
    }
  }

  showDirectResult(carrier, message, buttonText, href) {
    if (!this.directResult || !this.resultBtn || !this.resultMsg || !this.resultCarrier) return;
    this.resultCarrier.textContent = carrier;
    this.resultMsg.textContent = message;
    this.resultMsg.dir = this.isArabic ? "rtl" : "ltr";
    this.resultBtn.href = href;
    this.resultBtn.textContent = buttonText;
    this.directResult.style.display = "block";
    this.directResult.scrollIntoView({ behavior: "smooth", block: "nearest" });
  }

  onOrderSubmit(e) {
    e.preventDefault();
    this.clearNotice();
    if (this.directResult) this.directResult.style.display = "none";

    const rawOrder = (this.orderRefInput.value || "").trim();
    const cleanOrder = rawOrder.replace(/^#/, "");
    const contact = (this.orderContactInput.value || "").trim();

    if (!cleanOrder) {
      this.showNotice(this.isArabic ? "يرجى إدخال رقم الطلب." : "Please enter your Order Number.", "error");
      this.orderRefInput.focus();
      return;
    }

    const isEmail = contact.includes("@") && contact.includes(".");
    const isPhone = /^[+\d][\d\s\-()]{6,20}$/.test(contact);

    if (!contact || (!isEmail && !isPhone)) {
      this.showNotice(this.isArabic ? "يرجى إدخال بريد إلكتروني صالح أو رقم هاتف صحيح." : "Please enter a valid email address or phone number.", "error");
      this.orderContactInput.focus();
      return;
    }

    const shoragesUrl = `https://shorages.track.ordercx.com/?email_or_phone=${encodeURIComponent(contact)}&order_ref=${encodeURIComponent(cleanOrder)}`;

    const isolatedOrder = `\u2068#${cleanOrder}\u2069`;
    this.showDirectResult(
      this.isArabic ? "تتبع الطلب" : "Order tracking",
      this.isArabic ? `يجري فتح صفحة التتبع المباشر للطلب ${isolatedOrder}. إذا لم تُفتح، استخدم الزر أدناه.` : `Opening live tracking for order ${isolatedOrder}. If it doesn’t open, use the button below.`,
      this.isArabic ? "افتح صفحة التتبع المباشر ←" : "Open Live Tracking Portal →",
      shoragesUrl
    );

    window.open(shoragesUrl, "_blank", "noopener,noreferrer");
  }

  onCourierSubmit(e) {
    e.preventDefault();
    this.clearNotice();
    if (this.directResult) this.directResult.style.display = "none";

    const val = (this.courierTrackingInput.value || "").trim();
    if (!val) {
      this.showNotice(this.isArabic ? "يرجى إدخال رقم التتبع." : "Please enter your tracking number.", "error");
      this.courierTrackingInput.focus();
      return;
    }

    // Check if user entered an order number instead
    if (/^#?\d{3,6}$/.test(val)) {
      this.showNotice(this.isArabic ? "يبدو أنك أدخلت رقم طلب. انتقل إلى تبويب «رقم الطلب ومعلومات التواصل» للتتبع باستخدام بريدك الإلكتروني أو رقم هاتفك." : "Tip: It looks like you entered an Order Number. Switch to the 'Order Number & Contact' tab to track with your email/phone.", "warning");
      return;
    }

    // 1. Shorages Shipment ID (e.g. MTVDCP2LSOVMX1)
    if (/^MTV[A-Z0-9]{8,14}$/i.test(val) || (val.length === 14 && /^[A-Z0-9]+$/i.test(val))) {
      const shoragesShipmentUrl = `https://shorages.track.ordercx.com?shipment_id=${encodeURIComponent(val.toUpperCase())}`;
      const shipmentId = `\u2068${val.toUpperCase()}\u2069`;
      this.showDirectResult(
        this.isArabic ? "شوراجز" : "Shorages Fulfillment Hub",
        this.isArabic ? `تم العثور على الشحنة رقم ${shipmentId}. اضغط أدناه لعرض حالة التوصيل مباشرة.` : `Shorages shipment ${shipmentId} found. Open the live delivery status below.`,
        this.isArabic ? "افتح تتبع شوراجز ←" : "Open Shorages Tracking →",
        shoragesShipmentUrl
      );
      window.open(shoragesShipmentUrl, "_blank", "noopener,noreferrer");
      return;
    }

    // 2. Aramex AWB (10 to 11 digits, typically starting with 3)
    if (/^3\d{9,10}$/.test(val) || /^\d{10,12}$/.test(val)) {
      const aramexUrl = `https://www.aramex.com/track/results?ShipmentNumber=${encodeURIComponent(val)}`;
      const awb = `\u2068${val}\u2069`;
      this.showDirectResult(
        "Aramex",
        this.isArabic ? `تم العثور على رقم بوليصة الشحن ${awb}. يمكنك فتح صفحة أرامكس الرسمية أدناه.` : `Aramex tracking number ${awb} found. Open the official Aramex tracker below.`,
        this.isArabic ? "افتح تتبع أرامكس ←" : "Open Official Aramex Tracking →",
        aramexUrl
      );

      this.initOrderTracking(val, "100010"); // 100010 is Aramex in 17Track
      return;
    }

    // 3. Multi-carrier generic tracking
    this.initOrderTracking(val, "0");
  }

  initOrderTracking(trackingNum, carrierCode = "0") {
    if (typeof YQV5 !== "undefined" && typeof YQV5.trackSingle === "function") {
      YQV5.trackSingle({
        YQ_ContainerId: "ot-container",
        YQ_Height: 560,
        YQ_Fc: carrierCode,
        YQ_Lang: "en",
        YQ_Num: trackingNum
      });
      setTimeout(() => {
        const container = document.getElementById("ot-container");
        if (container) {
          container.scrollIntoView({ behavior: "smooth", block: "nearest" });
        }
      }, 350);
    } else {
      console.warn("YQV5 tracking library not yet loaded.");
    }
  }

  checkUrlParams() {
    try {
      const params = new URLSearchParams(window.location.search);
      const trackNum = params.get("tracking_number") || params.get("tracking") || params.get("awb");
      const orderRef = params.get("order") || params.get("order_ref") || params.get("order_number");
      const contact = params.get("email") || params.get("phone") || params.get("email_or_phone");

      if (trackNum) {
        this.switchTab("courier");
        if (this.courierTrackingInput) {
          this.courierTrackingInput.value = trackNum;
          this.onCourierSubmit(new Event("submit"));
        }
      } else if (orderRef) {
        this.switchTab("order");
        if (this.orderRefInput) this.orderRefInput.value = orderRef;
        if (contact && this.orderContactInput) this.orderContactInput.value = contact;
        if (orderRef && contact) {
          this.onOrderSubmit(new Event("submit"));
        }
      }
    } catch (e) {
      console.error("URL params check error:", e);
    }
  }
});
